import type { IAccount } from "@apis/accounts/types"

export const serializeProspectData = (accountData: IAccount) => {
  const { membership_profile } = accountData

  return {
    prospect_guid: membership_profile.prospect_guid,
    membership_profile_id: membership_profile.membership_profile_id,
  }
}
